module.exports = __webpack_public_path__ + "KaTeX_Math-BoldItalic.75a18dad.ttf";